import { render, staticRenderFns } from "./sAddPerson.vue?vue&type=template&id=04784f4e&"
import script from "./sAddPerson.vue?vue&type=script&lang=js&"
export * from "./sAddPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports